import '../css/Title.css'

export default function Title() {
    return (
        <div className="title-wrap">
            <h1 className="site-title">mag</h1>
        </div>
    )
}
